module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/modules/$.iterators.js
// module id = 224
// module chunks = 0